export enum AGGridFilter {
  SetColumnFilter = 'agSetColumnFilter'
}